import ViewMateBusinessCart from 'software_products/components/ViewMateBusinessCart';
import renderSubscriptionProduct from 'software_products/renderSubscriptionProduct';

renderSubscriptionProduct(ViewMateBusinessCart);
